module.exports = __webpack_public_path__ + "img/restriction_free.png";